module.exports = __webpack_public_path__ + "static/media/user.e33746d0.svg";